export default __webpack_public_path__ + "static/media/element_6.39b8f7f3.webp";